import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Commons from "../../utils/Commons";
import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  Animated,
  PanResponder,
  TouchableHighlight,
  TouchableOpacity,
  Dimensions,
} from "react-native";
// import { Video } from "expo-av";
import { Image } from 'expo-image'
const reactNativePackage = require("react-native/package.json");
const splitVersion = reactNativePackage.version.split(".");
const majorVersion = +splitVersion[0];
const minorVersion = +splitVersion[1];
let width = Commons.photoModalWidthDims().width / 2;
let height = Commons.photoModalWidthDims().height - 20;
let isMobile = false;
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
  },
  layoutIndicator: {
    height: 15,
    position: "absolute",
    bottom: 5,
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "transparent",
  },
  indicator: {
    margin: 3,
    opacity: 0.9,
  },
  indicatorSelected: {
    opacity: 1,
  },
  containerImage: {
    flex: 1,
    width: Commons.getWidth()
  },
  overlay: {
    opacity: 0.5,
    backgroundColor: "white",
  },
  layoutText: {
    position: "absolute",
    paddingHorizontal: 15,
    bottom: 30,
    left: 0,
    right: 0,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: "transparent",
  },
  textTitle: {
    fontWeight: '700',
    fontSize: 15,
    color: "white",
  },
  textCaption: {
    fontWeight: '400',
    fontSize: 12,
    color: "white",
  },
});

let done = true;
export default class Slideshow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      position: 0,
      height: Commons.photoModalWidthDims().height,
      width: Commons.photoModalWidthDims().width,
      scrolling: false,
    };

    this._autoPlayTimer = null;
  }

  _onRef(ref) {
    this._ref = ref;
    if (ref && this.state.position !== this._getPosition()) {
      this._move(this._getPosition());
    }
  }

  _move(index) {
    try {
      done = false;
      const isUpdating = index !== this._getPosition();
      const x = this.props.imgWidth ?
        this.props.imgWidth * index
        :
        (this.state.width / this.props.dataSource.length) * index;

      if (majorVersion === 0 && minorVersion <= 19) {
        // this._ref.scrollTo(0, x, true); // use old syntax
      } else {
        this._ref.scrollTo({ x, y: 0, animated: true });
      }
      this.setState({ position: index });
      if (isUpdating && this.props.onPositionChanged) {
        this.props.onPositionChanged(index);
      }

    } catch (err) {
    }
    setTimeout(() => {
      done = true;
    }, 1000);
  }

  _getPosition() {
    if (typeof this.props.position === "number") {
      return this.props.position;
    }
    return this.state.position;
  }

  _startAutoPlay() {
    if (this.props.autoPlay && this.props.dataSource.length > 1) {
      this._stopAutoPlay(); // Clear any existing timer
      this._autoPlayTimer = setInterval(() => {
        if (!this.state.scrolling) { // Only auto-advance if not manually scrolling
          this._next();
        }
      }, this.props.autoPlayInterval || 4000);
    }
  }

  _stopAutoPlay() {
    if (this._autoPlayTimer) {
      clearInterval(this._autoPlayTimer);
      this._autoPlayTimer = null;
    }
  }

  _resetAutoPlay() {
    if (this.props.autoPlay) {
      this._stopAutoPlay();
      setTimeout(() => {
        this._startAutoPlay();
      }, 4000); // Wait a bit before restarting
    }
  }

  _next() {
    const pos =
      this.state.position === this.props.dataSource.length - 1
        ? 0
        : this.state.position + 1;
    this._move(pos);
    // this.setState({ position: pos });
  }

  _prev() {
    const pos =
      this.state.position === 0
        ? this.props.dataSource.length - 1
        : this.state.position - 1;
    this._move(pos);
    // this.setState({ position: pos });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.position !== this.props.position) {
      // this._move(this.props.position);
    }

    // Handle autoPlay prop changes
    if (prevProps.autoPlay !== this.props.autoPlay) {
      if (this.props.autoPlay) {
        this._startAutoPlay();
      } else {
        this._stopAutoPlay();
      }
    }

    // if (prevProps.position !== this.props.position && typeof this.props.position === "number") {
    //   this._move(this.props.position);
    // }
  }

  componentDidMount() {
    // Start auto-play after component mounts
    this._stopAutoPlay();
    if (this.props.width && this.props.height) {
      width = this.props.width;
      height = this.props.height;
    }
    setTimeout(() => {
      this.setState({ scrolling: false });
      this._startAutoPlay(); // Resume auto-play after user stops dragging
    }, 1500);
  }

  UNSAFE_componentWillMount() {
    const width = this.state.width;

    const release = (e, gestureState) => {
      const width = this.state.width;
      const relativeDistance = gestureState.dx / width;
      const vx = gestureState.vx;
      let change = 0;

      if (relativeDistance < -0.5 || (relativeDistance < 0 && vx <= 0.5)) {
        change = 1;
      } else if (
        relativeDistance > 0.5 ||
        (relativeDistance > 0 && vx >= 0.5)
      ) {
        change = -1;
      }
      const position = this._getPosition();
      if (position === 0 && change === -1) {
        change = 0;
      } else if (position + change >= this.props.dataSource.length) {
        change = this.props.dataSource.length - (position + change);
      }
      // this._move(position + change);
      return true;
    };

    this._panResponder = PanResponder.create({
      onPanResponderRelease: release,
    });

    this._interval = setInterval(() => {
      const newWidth = this.props.width || Commons.getWidth();
      if (newWidth !== this.state.width) {
        this.setState({ width: newWidth });
      }
    }, 16);
  }

  componentWillUnmount() {
    clearInterval(this._interval);
    this._stopAutoPlay(); // Clean up auto-play timer
  }

  render() {
    const position = this._getPosition();
    if (this.props.width && this.props.height) {
      width = this.props.width;
      height = this.props.height;
    }
    // Guard against non-positive width being passed down to snapToInterval,
    // which crashes natively (NSInvalidArgumentException) on iOS.
    if (!width || width <= 0) width = 1;
    if (!height || height <= 0) height = 1;
    // const { width, height } = Commons.photoModalWidthDims();
    const { filterID, isAdvProducts, showOrderNow, onTouch } = this.props;
    const snapInterval = (this.props.imgWidth && this.props.imgWidth > 0) ? this.props.imgWidth : width;
    return (
      <View style={[{ height: this.props.height || 182, width: width }]}>
        {/* SECTION IMAGE */}
        <ScrollView
          ref={(ref) => this._onRef(ref)}
          decelerationRate={0.98}
          horizontal
          showsHorizontalScrollIndicator={false}
          disableIntervalMomentum={true}
          pagingEnabled={this.props.pagingDisabled ? false : true}
          snapToInterval={snapInterval}
          snapToAlignment="start"
          disableScrollViewPanResponder={false}
          scrollEventThrottle={100}
          scrollEnabled={this.props.scrollEnabled}
          onScroll={(e) => {
            try {
              const x = e.nativeEvent.contentOffset.x;
              const imgWidth = this.props.imgWidth || width;
              let index = Math.round(x / imgWidth);
              if (index < 0) index = 0;
              if (index >= this.props.dataSource.length) index = this.props.dataSource.length - 1;
              if (index !== this.state.position) {
                this.setState({ position: index });
                if (this.props.onPositionChanged) {
                  this.props.onPositionChanged(index);
                }
                this._resetAutoPlay();
              }
            } catch (error) {
              console.error("Error in onScroll:", error);
            }
          }}
          {...this._panResponder.panHandlers}
          style={[styles.container, { height: this.props.height || 182, width: width, }]}
          contentContainerStyle={{ flexDirection: "row", flexGrow: 1 }}
        >
          {this.props.dataSource.map((image, index) => {
            if (image.view) {
              return image.view;
            }
            const imageObject =
              typeof image.url === "string" ? { uri: image.url } : image.url;
            const textComponent = (
              <View style={styles.layoutText}>
                {image.title === undefined ? null : (
                  <Text style={styles.textTitle}>{image.title}</Text>
                )}
                {image.caption === undefined ? null : (
                  <Text style={styles.textCaption}>{image.caption}</Text>
                )}
              </View>
            );
            const imageComponent = (
              <TouchableOpacity key={index} onPress={() => {
                if (onTouch) onTouch(index);
              }} delayPressIn={200}
                style={{ height: this.props.height || 180, width: width, borderRadius: 12, overflow: 'hidden' }}>
                <Image
                  source={imageObject}
                  resizeMode={this.props.resizeMode || "cover"}
                  style={[{ height: this.props.height || 180, width: width - 5, borderRadius: 12 }]}
                />
                {/* {textComponent} */}
              </TouchableOpacity>
            );
            const videoComponent = (
              <View>
                {/* <Video
                  source={imageObject}
                  rate={1.0}
                  volume={1.0}
                  isMuted={false}
                  resizeMode="cover"
                  shouldPlay
                  isLooping
                  style={{ width, height }}
                /> */}
                {textComponent}
              </View>
            );
            const imageComponentWithOverlay = (
              // <View key={index} style={styles.containerImage}>
              // <View style={styles.overlay}>
              <Image source={imageObject} style={{ height: 176, width }} />
              // </View>
              // {textComponent}
              // </View>
            );
            if (image.url.indexOf("mp4") > -1) {
              return videoComponent;
            }
            if (this.props.onPress) {
              return (
                <TouchableOpacity
                  key={index}
                  style={{ height, width }}
                  onPress={() => this.props.onPress({ image, index })}
                  delayPressIn={200}
                >
                  {this.props.overlay
                    ? imageComponentWithOverlay
                    : imageComponent}
                </TouchableOpacity>
              );
            }
            return this.props.overlay
              ? imageComponentWithOverlay
              : imageComponent;
          })}
        </ScrollView>
        {/* END SECTION IMAGE */}
        {/* SECTION INDICATOR */}
        {
          this.props.dataSource.length > 1 &&
          <View style={[styles.layoutIndicator, { bottom: this.props.indicatorBelow ? -25 : 5 }]}>
            {this.props.dataSource.map((image, index) => (
              <TouchableOpacity
                key={index}
                onPress={() => { this._move(index); }}
                style={[
                  [
                    styles.indicator,
                    setIndicatorSize(this.props.indicatorSize),
                    setIndicatorColor(this.props.indicatorColor),
                  ],
                  position === index && [
                    styles.indicatorSelected,
                    setIndicatorColor(this.props.indicatorSelectedColor),
                  ],
                ]}
              >
                <View />
              </TouchableOpacity>
            ))}
          </View>
        }
        {/* END SECTION INDICATOR */}
        {/* SECTION ARROW LEFT */}
        <View
          style={[
            layoutArrow(this.props.height, this.props.arrowSize),
            { left: 10 },
          ]}
        >
          <TouchableOpacity onPress={() => {
            this.setState({ scrolling: true });
            this._stopAutoPlay();
            this._prev();
            setTimeout(() => {
              this.setState({ scrolling: false });
              this._startAutoPlay(); // Restart auto-play after manual navigation
            }, 1500);
          }}>
            {this.props.arrowLeft == undefined ? (
              <View
                style={[
                  iconArrow(this.props.arrowSize),
                  iconArrowLeft(this.props.arrowSize),
                ]}
              />
            ) : (
              this.props.arrowLeft
            )}
          </TouchableOpacity>
        </View>
        {/* END SECTION ARROW LEFT */}
        {/* SECTION ARROW RIGHT */}
        <View
          style={[
            layoutArrow(this.props.height, this.props.arrowSize),
            { right: 10 },
          ]}
        >
          <TouchableOpacity onPress={() => {
            this.setState({ scrolling: true });
            this._stopAutoPlay();
            this._next();
            setTimeout(() => {
              this.setState({ scrolling: false });
              this._startAutoPlay(); // Restart auto-play after manual navigation
            }, 1500);
          }}>
            {this.props.arrowRight == undefined ? (
              <View
                style={[
                  iconArrow(this.props.arrowSize),
                  iconArrowRight(this.props.arrowSize),
                ]}
              />
            ) : (
              this.props.arrowRight
            )}
          </TouchableOpacity>
        </View>
        {/* END SECTION ARROW RIGHT */}
      </View>
    );
  }
}

Slideshow.defaultProps = {
  height: 176,
  indicatorSize: 8,
  indicatorColor: "#CCCCCC",
  indicatorSelectedColor: "#FFFFFF",
  scrollEnabled: true,
  arrowSize: 16,
  autoPlay: false,
  autoPlayInterval: 3000,
};

Slideshow.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      caption: PropTypes.string,
      url: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,
  indicatorSize: PropTypes.number,
  indicatorColor: PropTypes.string,
  indicatorSelectedColor: PropTypes.string,
  height: PropTypes.number,
  position: PropTypes.number,
  scrollEnabled: PropTypes.bool,
  containerStyle: PropTypes.object,
  overlay: PropTypes.bool,
  arrowSize: PropTypes.number,
  arrowLeft: PropTypes.object,
  arrowRight: PropTypes.object,
  onPress: PropTypes.func,
  onPositionChanged: PropTypes.func,
  autoPlay: PropTypes.bool,
  autoPlayInterval: PropTypes.number,
};

const setIndicatorSize = function (size) {
  return {
    width: size,
    height: size,
    borderRadius: size / 2,
  };
};

const setIndicatorColor = function (color) {
  return {
    backgroundColor: color,
  };
};

const layoutArrow = function (imageHeight, iconHeight) {
  return {
    position: "absolute",
    backgroundColor: "transparent",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    //top: (imageHeight - iconHeight) / 2,
    top: (height + 25 - iconHeight) / 2,
    // bottom: (imageHeight - iconHeight) / 2
  };
};

const iconArrow = function (iconHeight) {
  return {
    width: 0,
    height: 0,
    margin: 5,
    backgroundColor: "transparent",
    borderStyle: "solid",
    borderTopColor: "transparent",
    borderBottomColor: "transparent",
    borderTopWidth: iconHeight / 2,
    borderBottomWidth: iconHeight / 2,
  };
};

const iconArrowRight = function (iconHeight) {
  return {
    borderRightWidth: 0,
    borderLeftWidth: (iconHeight * 75) / 100,
    borderRightColor: "transparent",
    borderLeftColor: "white",
  };
};

const iconArrowLeft = function (iconHeight) {
  return {
    borderRightWidth: (iconHeight * 75) / 100,
    borderLeftWidth: 0,
    borderRightColor: "white",
    borderLeftColor: "transparent",
  };
};
